import type { UnifiedProduct } from '@noths/polaris-client-unified-product-service';

// UPS drops expired promotions at read time, so an empty list is the only "off" state.
// Trimmed so an id can never miss authored content on whitespace.
export const adaptUnifiedProductPromotionsToStore = (
  unifiedProduct: UnifiedProduct | null,
): string[] =>
  (unifiedProduct?.promotions ?? [])
    .map((promotion) => promotion.id.trim())
    .filter((id) => id !== '');
